import { Pipe, PipeTransform } from '@angular/core';
import {Constants} from '../constants';

@Pipe({
  name: 'operatorFilter'
})
export class OperatorFilterPipe implements PipeTransform {

  transform(operators: any, attribute?: any): any {
    if (!operators) {
      return [];
    }
    if (!attribute) {
      return operators;
    }

    return operators.filter((item) => item.type === 'all' ||
      (item.type === Constants.NUMBER &&
        attribute.datatype.toUpperCase() === Constants.NUMBER));
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/pipes/operator-filter.pipe.ts